export enum CustomNotificationType {
    Success,
    Error,
    Info,
    Warning
}

export interface CustomNotification {
    type: CustomNotificationType;
    icon: string;
    message: string;
}
